module.exports = __webpack_public_path__ + "img/2025-04-12b_2.c4337a87.jpg";